import { createTable, Link as LinkMagik, Pagination } from "@inmagik/magik-ui"
import { FiltersBase, Edizione } from "../../types"
import { Link } from "react-router-dom"
import { useMemo } from "react"
import { PAGE_SIZE } from "../../constants"

const Table = createTable<Edizione>()

export function TableEdizioni({
  edizioni,
  setFilters,
  filters,
  count,
  fullCount,
  showOpera = true,
  actionLink,
}: {
  edizioni: Edizione[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
  showOpera?: boolean
  actionLink?: (v?: Edizione) => void
}) {
  const numPages = useMemo(() => {
    if (!edizioni) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [edizioni, count])

  return (
    <Table
      data={edizioni}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Column
        title="Nome"
        name="titolo_completo"
        sortable
        width="400px"
        render={(edizione) =>
          actionLink ? (
            <LinkMagik className="text-dark" onClick={() => actionLink(edizione)} style={{ cursor: "pointer" }}>
              {edizione.titolo_completo}
            </LinkMagik>
          ) : (
            <Link to={`/edizioni/edizioni/${edizione.id}/dettaglio`}>
              <LinkMagik className="text-dark">{edizione.titolo_completo}</LinkMagik>
            </Link>
          )
        }
        stickyLeft
      />
      {showOpera && (
        <Table.Column
          title="Opera"
          name="opera__titolo"
          sortable
          width="300px"
          render={(edizione) => edizione.opera_data?.titolo}
        />
      )}
      <Table.Column
        title="Anno"
        name="anno"
        sortable
        width="minmax(max-content, 1fr)"
        render={(edizione) => edizione.anno}
      />
      <Table.Column
        title="Città"
        name="citta__nome"
        sortable
        width="minmax(max-content, 1fr)"
        render={(edizione) => (
          <span>
            {edizione.citta_data?.nome} {edizione.citta_without_coords && <span style={{ color: "red" }}>(senza coordinate)</span>}
          </span>
        )}
      />
      <Table.Column
        title="Bozza"
        name="bozza"
        sortable
        width="minmax(max-content, 1fr)"
        render={(edizione) => (edizione.bozza ? "Si" : "No")}
      />p

      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} edizioni
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
